<template>
  <div>
    <DynamicFormRender :formId="formId" :filters="filter"></DynamicFormRender>
    <DynamicFormRender :formId="formId2" :filters="filter2"></DynamicFormRender>
    <hr>
    <button type="button" class="btn  btn-lg btn-success" @click="submitForm()">submit</button>
  </div>
</template> 
<script>

import constants from '@/assets/js/constants.js';
import DynamicFormRender from '@/components/DynamicFormRender.vue';
import FomrBuilderUtil from '@/utils/formBuilderHelper';
import axios from "axios";

export default {
  name: 'formioRender',
  data() {
    return {
      formId: 'testing',
      formId2: 'testing2',
      dynamicFormDetails: [],
      // filter: {} = { id: '', templateName: '', templateId: '', referenceNumber: '', structureId: 0, categoryId: 0, templateId: 1427, url: "http://localhost:5000/api/" },
      filter2: {} = { id: '', templateName: '', templateId: '', referenceNumber: '', structureId: 18074, categoryId: 0, templateId: 0, url: "http://localhost:5000/api/" }
    };
  },

  beforeMount() {
  },

  mounted() {
  },

  methods: {
    firstFormHandler(event) {
      alert("Dynamic Form Data" + JSON.stringify(event.detail.data));
    },

    submitForm() {
      //
      // var form = new FomrBuilderUtil([]);
      // var filter = this.filter;
      // form.invoke(filter, this.firstFormHandler);

      var form2 = new FormBuilderUtil([]);
      var filter2 = this.filter2;
      form2.invoke(filter2, this.firstFormHandler);
    },
  },
  components: { DynamicFormRender }
}
</script>
